export default __webpack_public_path__ + "static/rare-7d47305202210928d654f9ae4b561a95.png";